import {useCallback, useMemo} from 'react';
import {Appliance as ApplianceInterface} from 'components/customer/Product/entity/Appliance';
import {Appliance as NewAppliance} from 'components/customer/Product/Appliance/entity/Appliance';
import {RANGEHOOD} from 'components/customer/Product/store/productApi';
import {useFormikContext} from 'formik';

export interface ApplianceField {
    name: string;
    displayName: string;
    options: {
        applianceType: string;
        heightFieldName: string;
        heightFieldMoreInfo: string;
        advancedCheckboxFieldName: string;
        moreInfo: string;
    };
}

export const useFieldHelpers = (type: number, field: ApplianceField) => {
    const {setFieldValue} = useFormikContext();

    const {heightFieldName, heightFieldMoreInfo, advancedCheckboxFieldName} =
        useMemo(() => {
            const heightFieldName = field.options['heightFieldName'];
            const heightFieldMoreInfo = field.options['heightFieldMoreInfo'];
            const advancedCheckboxFieldName =
                field.options['advancedCheckboxFieldName'];

            return {
                heightFieldName,
                heightFieldMoreInfo,
                advancedCheckboxFieldName,
            };
        }, [field]);

    const formConfig = useMemo(() => {
        return type == RANGEHOOD
            ? []
            : [
                  {
                      name: heightFieldName,
                      displayName: 'Opening Height',
                      type: 'size',
                      value: 0,
                      options: {
                          moreInfo: heightFieldMoreInfo,
                          enabled: `${advancedCheckboxFieldName} == 0`,
                      },
                  },
                  {
                      name: advancedCheckboxFieldName,
                      displayName: 'Advanced Selection',
                      type: 'boolean',
                      value: 0,
                  },
              ];
    }, [type, heightFieldName, heightFieldMoreInfo, advancedCheckboxFieldName]);

    const setApplianceHeight = useCallback(
        (value: number) => {
            void setFieldValue(heightFieldName, value);
        },
        [heightFieldName]
    );

    const applianceHandler = (
        name: string,
        value?: string | null,
        options?: ApplianceInterface[] | NewAppliance[]
    ) => {
        if (options) {
            const selectedOption = options.find((option) => {
                if ('id' in option) {
                    return option.id == value;
                } else if ('externalCode' in option) {
                    return option.externalCode == value;
                }

                return false;
            });

            if (selectedOption) {
                void setFieldValue(heightFieldName, selectedOption.height);
            }
        }
    };

    return {
        advancedCheckboxFieldName,
        formConfig,
        applianceHandler,
        setApplianceHeight,
    };
};
